var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn-toggle',{staticClass:"my-3",attrs:{"multiple":"","dense":"","color":"secondary"},on:{"change":_vm.change},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}},_vm._l((_vm.items),function(item,index){return _c('v-btn',{key:index,attrs:{"small":"","value":item.value}},[_vm._v(_vm._s(item.text))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }